import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Phone, Mail, MapPin, Image as ImageIcon } from 'lucide-react';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';

const API = process.env.REACT_APP_BACKEND_URL;
const LABELS = { winterizing: 'Winterizing', repair: 'Repair', installation: 'New Install', tuneup: 'Tune-Up' };
export const STATUSES = [
  { id: 'new', label: 'New' }, { id: 'called', label: 'Called' }, { id: 'quoted', label: 'Quoted' },
  { id: 'won', label: 'Won' }, { id: 'lost', label: 'Lost' },
];

const Photos = ({ e }) => (e.photos.length ? (
  <div className="o-photos">
    {e.photos.map((p, i) => (
      <a key={p.url} href={`${API}${p.url}`} target="_blank" rel="noreferrer" data-testid={`owner-photo-${e.id}-${i}`}>
        <img src={`${API}${p.url}`} alt={`Estimate ${i + 1}`} loading="lazy" />
      </a>
    ))}
  </div>
) : <p className="o-nophoto"><ImageIcon size={14} /> No photos</p>);

export const EstimateCard = ({ e, token, onChange }) => {
  const [note, setNote] = useState(e.note || '');
  const [saving, setSaving] = useState(false);

  const save = async (patch) => {
    setSaving(true);
    try {
      const { data } = await axios.patch(`${API}/api/owner/estimates/${e.id}`, patch, { headers: { Authorization: `Bearer ${token}` } });
      onChange({ ...e, ...data });
      toast.success(patch.status ? `Marked as ${patch.status}` : 'Note saved');
    } catch (err) {
      toast.error("Couldn't save", { description: 'Please try again.' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <article className={`o-card is-${e.status}`} data-testid={`owner-estimate-${e.id}`}>
      <div className="o-card-head">
        <h3>{e.name}</h3>
        <span>{new Date(e.created_at).toLocaleString()}</span>
      </div>
      <div className="o-tags">{e.services.map((s) => <span key={s}>{LABELS[s] || s}</span>)}</div>
      <p className="o-line"><Phone size={14} /> <a href={`tel:${e.phone}`}>{e.phone}</a></p>
      {e.email && <p className="o-line"><Mail size={14} /> <a href={`mailto:${e.email}`}>{e.email}</a></p>}
      <p className="o-line"><MapPin size={14} /> {e.address}</p>
      {e.details && <p className="o-details">{e.details}</p>}
      <Photos e={e} />
      <div className="o-status" role="group" aria-label="Status">
        {STATUSES.map((s) => (
          <button key={s.id} type="button" disabled={saving} onClick={() => s.id !== e.status && save(note !== (e.note || '') ? { status: s.id, note } : { status: s.id })}
            className={`o-status-btn st-${s.id}${e.status === s.id ? ' is-on' : ''}`} data-testid={`owner-status-${e.id}-${s.id}`}>
            {s.label}
          </button>
        ))}
      </div>
      <Textarea rows={2} value={note} onChange={(ev) => setNote(ev.target.value)} maxLength={2000}
        placeholder="Private note (e.g. quoted $450, call back Tuesday)" data-testid={`owner-note-${e.id}`} />
      {note !== (e.note || '') && (
        <Button size="sm" className="w-btn-primary o-note-save" disabled={saving} onClick={() => save({ note })} data-testid={`owner-note-save-${e.id}`}>
          Save note
        </Button>
      )}
    </article>
  );
};

export default EstimateCard;
